
import {Component, Vue, Prop, Watch} from "vue-property-decorator";

import preferencesService from "../../services/preferences.service";
import PreferenceSelectionEnrichissement
    from "@/components/enrichissement/selection/PreferenceSelectionEnrichissement.vue";
import FileSelectionEnrichissement from "@/components/enrichissement/selection/FileSelectionEnrichissement.vue";
import i18n from "@/plugins/vue-i18n";
import {namespace} from "vuex-class";

const userModule = namespace("userModule");

@Component({
    components: {PreferenceSelectionEnrichissement, FileSelectionEnrichissement}
})
export default class FilesEnrichissement extends Vue {

    tab = 0;
    items = [
        {tab: i18n.tc("my_files"), content: "FileSelectionEnrichissement"},
        {tab: i18n.tc("comptage.settings.selectfilter"), content: "PreferenceSelectionEnrichissement"},
    ];

    @Prop() readonly fileToUpload;
    @Prop() readonly preferenceFile;
    @Prop() readonly preferenceTrigger: boolean;
    @Prop() readonly setFile;

    @userModule.State
    public user!: any;

    @userModule.Action
    public getUser;

    files = [];
    filePreference = [];
    filePreferenceLoading = false;
    dialogSelectId = false;
    headersSelectId = [];
    itemsSelectId = [];
    idFieldFileInput = null;
    idFieldTypeFileInput = "siren";

    uploadingFile = false;
    isLoadingData = true;

    fileToUpdate = {};

    @Watch("preferenceTrigger")
    filePreferenceInit() {
        this.filePreferenceLoading = true;
        preferencesService.getPreferencesFilters(this.user.id, ['enrichment']).then((res: any) => {
            this.filePreference = res.data.message.Items;
            this.filePreferenceLoading = false;
        });
    }


    refreshFiles() {
        this.isLoadingData = true;
        preferencesService.getPreferencesFiles(this.user.id, ['enrichment']).then(res => {
            this.files = res.data.message.Items;
            this.isLoadingData = false;
        });
        this.filePreferenceInit();
    }

    created() {
        if (this.user && this.user.id) {
            this.refreshFiles();
            this.filePreferenceInit();
        } else {
            this.getUser().then(res => {
                this.refreshFiles();
                this.filePreferenceInit();
            });
        }
    }

    createdHeadersFile(items) {
        const headers = [];

        if (items && items.length > 0) {
            const length = Object.keys(items[0]).length - 2;
            for (let index = 0; index < length; index++) {
                headers.push({
                    text: index + "",
                    value: index + ""
                });
            }
        }

        return headers;
    }

    savePreferenceIdFile() {
        const identifier = {
            type: this.idFieldTypeFileInput,
            column: this.idFieldFileInput
        };
        preferencesService
            .updateFileRepellerIdentifier(
                this.itemsSelectId[0].fileId,
                identifier,
                this.user.id
            )
            .then(() => {
                this.refreshFiles();
                //this.enrichissement.files[0].identifiers = identifier;
            });
    }

    preview(item) {
        this.idFieldFileInput = null;
        this.idFieldTypeFileInput = "siren";
        this.itemsSelectId = [];
        this.headersSelectId = [];

        preferencesService.previewFile(item.uuid).then(file => {
            this.itemsSelectId = file.data.message.Items;
            this.headersSelectId = this.createdHeadersFile(
                file.data.message.Items
            );
            if (item.identifiers) {
                this.idFieldTypeFileInput = item.identifiers.type;
                this.idFieldFileInput = item.identifiers.column;
            }
        });
    }

    deleteFile(item) {
        preferencesService.deletePreferenceFilter(item.uuid, this.user.id).then(() => {
            this.filePreference = this.filePreference.filter(preferencefile => {
                return preferencefile.uuid !== item.uuid;
            });
            if (this.preferenceFile && this.preferenceFile.length > 0 && item.uuid === this.preferenceFile[0].uuid) {
                this.$emit('uploadPreferenceFile', []);
            }
        });
    }

    deleteFileRepeller(uuid) {
        this.isLoadingData = true;
        preferencesService.deletePreferenceFiles(uuid, this.user.id).then(() => {
            this.refreshFiles();
            if (this.fileToUpload && uuid === this.fileToUpload.uuid) {
                this.$emit('uploadFileSet', null, null, false);
            }
        });
    }

    dialogSelectIdSet(bool) {
        this.dialogSelectId = bool;
    }

    uploadFileSet(file, oldFile, trueUpload, fileObject) {
        this.$emit('uploadFileSet', file, oldFile, trueUpload, fileObject);
    }
}
